import { useRouter } from 'next/router';
import { isEmpty } from 'ramda';
import { useEffect, useMemo } from 'react';
import {
  useCurrentKidId,
  useGoBackOrToIndex,
  useLoadedKids,
  useQuiz,
  useSelfInfo,
  useSetAllValues,
  useSetCurrentStepData,
} from '../context/QuizDataContext';
import { nestFlatKidDataToSteps } from '../services/KidService';
import { QuizStorageKey } from '../types';
import { retrieveStoredStepData, storageCurrentStepData } from '../utils';

const useReturnToLastStep = () => {
  const loadedKids = useLoadedKids();
  const selfInfo = useSelfInfo();
  const setAllValues = useSetAllValues();
  const setCurrentStepData = useSetCurrentStepData();
  const goBackOrToIndex = useGoBackOrToIndex();
  const currentKidId = useCurrentKidId();
  const { selectKid } = useQuiz();
  let {
    query: { kid },
  } = useRouter();
  if (Array.isArray(kid)) kid = kid[0];
  const { lastKidName: currentKidName, lastSelectedKids } = retrieveStoredStepData();
  const lastKidName = kid || currentKidName;
  kid && storageCurrentStepData(QuizStorageKey.LAST_KID_NAME, kid as string);

  useEffect(() => {
    if (!lastKidName || currentKidId || isEmpty(loadedKids) || isEmpty(selfInfo)) {
      return;
    }

    const kidInfo = loadedKids.find(item => item.name === lastKidName);

    if (kidInfo) {
      const quizValues = nestFlatKidDataToSteps({}, kidInfo);
      const kidQuizStep = Number(kidInfo.last_quiz_step) + 1;

      setAllValues(quizValues).then(() => {
        setCurrentStepData(kidQuizStep, { kidId: kidInfo.id, selectedKids: lastSelectedKids || [] });
        selectKid(kidInfo.id);
        goBackOrToIndex(kidQuizStep);
      });
    }
  }, [loadedKids, selfInfo, currentKidId, lastKidName, lastSelectedKids]);

  const incompleteKids = useMemo(() => loadedKids.filter(item => !item.is_quiz_completed), [loadedKids]);

  return { incompleteKids, lastKidName };
};

export default useReturnToLastStep;
